<template>
	<div class="col-12 p-0">
		<table v-if="schedules.length" class="leader-board-table table table-striped table-bordered mt-md-4">
			<tbody>
			<tr v-for="row in schedules">
				<td class="leader-board-table--position px-4">
					<h3 class="text-primary m-0">{{row.formatted_date.day}}</h3>
					<small class="text-light">{{row.formatted_date.month}}</small>
				</td>
				<td class="container">
					<div class="row text-center">
						<div class="col-12 my-auto leader-board-table--name">
							<div class="w-100 leader-board-table--value">{{row.venue.name}}</div>
							<div class="w-100 leader-board-table--label">Scheduled by {{row.user.first_name + ' ' + row.user.last_name}}</div>
						</div>
					</div>
				</td>
				<td class="px-2">
					<a :href="getEditLink(row.id)" class="btn btn-primary px-md-4">Edit</a>
				</td>
			</tr>
			</tbody>
		</table>
		<h5 v-else>No schedules</h5>
	</div>
</template>

<script>
	export default {
		props:[
			'schedules',
			'schedule_edit_url'
		],

		methods: {
			getEditLink(id){
				return this.schedule_edit_url.replace('?', id);
			}
		}
	}
</script>
